import React, { Component } from 'react';
import { arrToObj } from 'utils/generic';
import { connect } from 'react-redux';
import { addSubsidiary, updateSubsidiary } from 'actions/consolidationsActions';
import Select from 'components/shared/Select';

class SubsidiaryModal extends Component {
  constructor(props) {
    super(props);
    this.onMapChange = this.onMapChange.bind(this);
    this.cfObj = this.props.data.cfObj;
    this.subPeriodNames = this.cfObj.accounts.periodIds.map(
      (periodId) => this.cfObj.accounts.periodsById[periodId].name
    );
    this.doUpdate = this.props.data.subsidiary !== null;
    let periodsMap = [];
    this.filenameChanged = false;
    if (this.doUpdate) {
      periodsMap = this.props.periodIds.map((periodId) => {
        let cfPeriodId = this.props.data.subsidiary.periodsMap[periodId];
        return [periodId, this.cfObj.accounts.periodIds.indexOf(cfPeriodId)];
      });
      // When updating add warning if filename is not the same
      this.filenameChanged =
        this.props.data.filename !== this.props.data.subsidiary.filename;
    } else {
      periodsMap = this.props.periodIds.map((periodId) => {
        return [periodId, -1];
      });
    }
    this.state = {
      name: this.cfObj.client.name,
      filename: this.props.data.filename,
      // periodsMap: [[periodId, selectedPeriodIdx], ...]
      periodsMap,
    };
  }

  onMapChange(e) {
    let index = parseInt(e.target.id, 10);
    let value = parseInt(e.target.value, 10);
    this.setState({
      periodsMap: [
        ...this.state.periodsMap.slice(0, index),
        [this.props.periodIds[index], value],
        ...this.state.periodsMap.slice(index + 1),
      ],
    });
  }

  handleInputChange = (event) => {
    const name = event.target.name;
    this.setState({
      [name]: event.target.value,
    });
  };

  duplicatedPeriodsExist = () => {
    let selectedPeriods = this.state.periodsMap
      .map(([periodId, selectedPeriodId]) => selectedPeriodId)
      .filter((selectedPeriodId) => selectedPeriodId !== -1);
    return new Set(selectedPeriods).size !== selectedPeriods.length;
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const sub = {
      ...this.state,
      // convert state.periodsMap which is an array with indicies as values
      // to periodsMap which should be object with periodIds as values
      periodsMap: arrToObj(
        this.state.periodsMap.map(([periodId, selectedPeriodIdx]) => {
          const selectedPeriodId =
            selectedPeriodIdx >= 0
              ? this.cfObj.accounts.periodIds[selectedPeriodIdx]
              : null;
          return { [periodId]: selectedPeriodId };
        })
      ),
      updated: new Date().toISOString(),
    };
    if (this.doUpdate) {
      this.props.updateSubsidiary(this.props.data.subId, sub, this.cfObj);
    } else {
      this.props.addSubsidiary(sub, this.cfObj);
    }
    this.props.onClose();
  };

  render() {
    const periodsMapSelectors = this.state.periodsMap.map(
      ([periodId, selectedPeriodIdx], i) => {
        return (
          <tr key={i}>
            <td>{this.props.periodsById[periodId].name}:</td>
            <td>
              <Select
                id={i}
                options={this.subPeriodNames}
                selectedIndex={selectedPeriodIdx}
                onChange={this.onMapChange}
              />
            </td>
          </tr>
        );
      }
    );

    return (
      <div className="SubsidiaryModal">
        <h2>{this.doUpdate ? 'Update' : 'Add'} Subsidiary</h2>
        <form onSubmit={this.handleSubmit}>
          <input
            name="name"
            type="text"
            value={this.state.name}
            // onChange={event => this.handleInputChange(event)}
            disabled={true}
            placeholder="Name"
          />
          <input
            name="filename"
            type="text"
            value={this.state.filename}
            disabled={true}
            className={this.filenameChanged && 'warning'}
            placeholder="Filename"
          />
          {this.filenameChanged && (
            <div className="messages">
              <p>
                <i className="fa fa-exclamation-triangle"></i> Filename has
                changed
              </p>
            </div>
          )}
          <table>
            <tbody>
              <tr key={-1}>
                <th>Periods</th>
                <th>Subsidiary periods</th>
              </tr>
              {periodsMapSelectors}
            </tbody>
          </table>
          <input
            type="submit"
            value={this.doUpdate ? 'Update' : 'Add'}
            className="btn"
            disabled={this.duplicatedPeriodsExist() || this.state.name === ''}
          />
        </form>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    // consolidations: state.consolidations,
    periodIds: state.accounts.periodIds,
    periodsById: state.accounts.periodsById,
  }),
  { addSubsidiary, updateSubsidiary }
)(SubsidiaryModal);
